/**
 * Tour ID pour le Welcome Tour global.
 */
export const WELCOME_TOUR_ID = 'admin-welcome';
